import { useEffect } from 'react';

const useZoomKeyboardShortcuts = (canvas, onZoomIn, onZoomOut, onZoomReset, onZoomToFit) => {
  useEffect(() => {
    if (!canvas) return;

    const handleKeyDown = (event) => {
      // Only handle shortcuts when not typing in input fields
      if (event.target.tagName === 'INPUT' || event.target.tagName === 'TEXTAREA') {
        return;
      }

      const isCtrlOrCmd = event.ctrlKey || event.metaKey;

      switch (true) {
        case isCtrlOrCmd && event.key === '=':
        case isCtrlOrCmd && event.key === '+':
          event.preventDefault();
          onZoomIn();
          break;
          
        case isCtrlOrCmd && event.key === '-':
          event.preventDefault();
          onZoomOut();
          break;
          
        case isCtrlOrCmd && event.key === '0':
          event.preventDefault();
          onZoomReset();
          break;
          
        case isCtrlOrCmd && event.key === '1':
          event.preventDefault();
          onZoomToFit();
          break;
          
        default:
          break;
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [canvas, onZoomIn, onZoomOut, onZoomReset, onZoomToFit]);
};

export default useZoomKeyboardShortcuts;
